import { GridSmartViewsWebComponent } from '../../../../grid/gridSmartViews';
import { IntegrityMonitorRulesSmartViewsController } from '../controller/IntegrityMonitorRulesSmartViewsController';
import { ViewType } from '../types';
import { Column, Filter } from '../../integrityMonitorRulesGrid/types';
import { IntegrityMonitorIdentifier } from '../../../common/utils/types';

export class IntegrityMonitorRulesSmartViewsWebComponent extends GridSmartViewsWebComponent<Column, Filter, ViewType> {
  private _ruleSetIdentifiers: Array<IntegrityMonitorIdentifier>;
  public controller: IntegrityMonitorRulesSmartViewsController;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: IntegrityMonitorRulesSmartViewsController,
    });
  }

  set ruleSetIdentifiers(value: Array<IntegrityMonitorIdentifier>) {
    this._ruleSetIdentifiers = value;
  }

  get ruleSetIdentifiers(): Array<IntegrityMonitorIdentifier> {
    return this._ruleSetIdentifiers ?? [];
  }
}
